import React from "react";

import ParentForm from "./parent-form";

const ParentsInformations = props => {
  return (
    <div>
      <h4>Parents' Informations</h4>
      <ParentForm {...props} index="0" />
      <ParentForm {...props} index="1" />
    </div>
  );
};

export default ParentsInformations;
